// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditCashInMethod } from '../../forms/FormEditCashInMethod/FormEditCashInMethod';

// props
export interface DialogEditCashInMethodProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditCashInMethod = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogEditCashInMethodProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveCashInMethod'),
					loading: isLoading,
					form: 'form-edit-cash-in-method',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('editCashInMethod'),
				variant: 'h3',
			}}>
			<FormEditCashInMethod onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
